import { render, staticRenderFns } from "./NpcEditors.vue?vue&type=template&id=eb008dc4&scoped=true&"
import script from "./NpcEditors.vue?vue&type=script&lang=js&"
export * from "./NpcEditors.vue?vue&type=script&lang=js&"
import style0 from "./NpcEditors.vue?vue&type=style&index=0&id=eb008dc4&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "eb008dc4",
  null
  
)

export default component.exports